import { differenceInDays } from 'date-fns';
import React from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Colors } from '../../../ui';
import { TextButton } from '../../../ui/TextButton';
import { useResolve } from '../../Container';
import { Copy, Flexer, LinkButton, Title } from '../../dashboard/elements/LayoutElements';
import { UpgradeButton } from '../../upgrade/UpgradeButton';
import { AccountModel } from '../AccountModel';

const Frame = styled.div<{ color: string }>`
    position: relative;
    padding: .5rem 3%;
    margin: .5rem;
    border-radius: .5rem;
    border: solid .125rem ${p => p.color};   
    /* font-weight: 450; */
    user-select: none; 
    color: ${Colors.text};

    ${Title} {
        color: ${Colors.text};
        font-size: 1rem;
        font-weight: 450;
    }
    ${Copy} {
        color: ${Colors.text};
        font-size: .8125rem;
    }
    ${TextButton} {
        text-decoration: underline;
    }
`;

const FreeSlice = () => {
    const { plan } = useObserver(useResolve(AccountModel));
    if (!plan?.name?.includes('free')) return null;

    return <Frame color={Colors.positive}>
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer flex="column" gap=".25" margin="0.125 0">
                <Title flush>You are on the {plan.label} Plan.</Title>
                <Copy flush>Usage limits apply.</Copy>
            </Flexer>
            <UpgradeButton variant="positive" />
        </Flexer>
    </Frame>;
};

const TrialSlice = () => {
    const { plan, trial } = useResolve(AccountModel);
    if (!plan?.name?.includes('trial') || !trial) return null;
    const now = new Date();
    const remaining = differenceInDays(trial.expiresAt, now);

    return <Frame color={remaining <= 5 ? Colors.mystery : Colors.positive}>
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer flex="column" gap=".25" margin="0.125 0">
                <Title flush>You are on a Free Trial.</Title>
                <Copy flush>{remaining <= 5 ? 'Only ' : ''}{Math.max(0, remaining)} days remaining.</Copy>
            </Flexer>
            <UpgradeButton variant="positive" />
        </Flexer>
    </Frame>;
};

const ExpiredSlice = () => {
    const { plan } = useResolve(AccountModel);
    if (!plan?.name?.includes('expired')) return null;

    return <Frame color={Colors.mystery}>
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer flex="column" gap=".25" margin="0.125 0">
                <Title flush>You trial has expired.</Title>
                <Copy flush>To continue, please upgrade!</Copy>
            </Flexer>
            <UpgradeButton label="View Plans" variant="mystery" />
        </Flexer>
    </Frame>;
};

const ClosedSlice = () => {
    const { plan } = useResolve(AccountModel);
    if (!plan?.name?.includes('closed')) return null;

    return <Frame color={Colors.mystery}>
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer flex="column" gap=".25" margin="0.125 0">
                <Title flush>Plan cancelled.</Title>
                <Copy flush>Never too late to reactivate!</Copy>
            </Flexer>
            <UpgradeButton label="Reactivate" variant="mystery" />
        </Flexer>
    </Frame>;
};

const FailedSlice = () => {
    const { id, plan } = useResolve(AccountModel);
    if (!plan?.name?.includes('failed')) return null;

    return <Frame color={Colors.mystery}>
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer flex="column" gap=".25" margin="0.125 0">
                <Title flush>Payment Failure!</Title>
                <Copy flush>Please update payment info.</Copy>
            </Flexer>
            <LinkButton target="_blank" href={`/billing/payment?accountId=${id}`} variant="negative">
                Update Now
            </LinkButton>
        </Flexer>
    </Frame>;
};

export const AdvertBlock = () => <>
    <FreeSlice />
    <TrialSlice />
    <ExpiredSlice />
    <ClosedSlice />
    <FailedSlice />
</>;
